import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';

interface DaySelectorProps {
  value: string; // "1-7" or "1,2,3"
  onChange: (value: string) => void;
}

export default function DaySelector({ value, onChange }: DaySelectorProps) {
  const [selectedDays, setSelectedDays] = useState<number[]>([]);

  const days = [
    { num: 1, label: 'Ma' },
    { num: 2, label: 'Di' },
    { num: 3, label: 'Wo' },
    { num: 4, label: 'Do' },
    { num: 5, label: 'Vr' },
    { num: 6, label: 'Za' },
    { num: 7, label: 'Zo' }
  ];

  // Parse value to selected days
  useEffect(() => {
    if (value.includes('-')) {
      const [start, end] = value.split('-').map(Number);
      const range = [];
      for (let i = start; i <= end; i++) {
        range.push(i);
      }
      setSelectedDays(range);
    } else {
      setSelectedDays(value.split(',').map(Number).filter(n => !isNaN(n)));
    }
  }, [value]);

  const toggleDay = (dayNum: number) => {
    const newDays = selectedDays.includes(dayNum)
      ? selectedDays.filter(d => d !== dayNum)
      : [...selectedDays, dayNum].sort();

    setSelectedDays(newDays);

    // Format output
    if (newDays.length === 0) {
      onChange('');
    } else if (newDays.length === 7 && newDays[0] === 1 && newDays[6] === 7) {
      onChange('1-7');
    } else {
      onChange(newDays.join(','));
    }
  };

  return (
    <div className="flex gap-2">
      {days.map(day => (
        <Button
          key={day.num}
          type="button"
          variant={selectedDays.includes(day.num) ? 'default' : 'outline'}
          size="sm"
          onClick={() => toggleDay(day.num)}
          className={selectedDays.includes(day.num) 
            ? 'bg-primary text-primary-foreground font-bold shadow-md' 
            : 'bg-muted text-muted-foreground hover:bg-muted/80'
          }
        >
          {day.label}
        </Button>
      ))}
    </div>
  );
}
